export const listingTypes = [
    {
        type: 'All',
        value: 0
    },
    {
        type: 'Desk',
        value: 1
    },
    {
        type: 'Office Room',
        value: 3
    },
    {
        type: 'Meeting Room',
        value: 2
    },
    {
        type: 'Virtual Office',
        value: 8
    }
];
